import { EVisitModalities } from 'util/visit-modalities'
import { useTranslation } from 'react-i18next'
import TestIds from '../../../util/TestIds'
import VisitScheduleType from '../../../util/visit-schedule-types'
import ScheduledVisitConfirmation from '../ScheduledVisitConfirmation'
import { APP_NAME } from 'util/constants'
import PendingVisit from 'types/visit/pendingVisit'
import Provider from 'types/provider/provider'
import { statesByValue } from 'util/states'
import { findCountryByValue } from 'util/countries'
import { useMemo } from 'react'
import VisitConfirmationLocation from '../VisitConfirmationLocation'
import { isSuccess } from 'util/helpers'

type VisitConfirmationChooser = {
  pendingVisit: PendingVisit
  provider?: Provider
  price?: string
}

const VisitConfirmationChooser = (props: VisitConfirmationChooser) => {
  const { t } = useTranslation()
  const { pendingVisit } = props
  const { scheduledType, modality, location, locationCountry, visitType } = pendingVisit || {}

  const displayLocation = useMemo(() => {
    if (location) {
      return statesByValue[location]
    }
    return findCountryByValue(locationCountry)
  }, [location, locationCountry])

  const successVisit = useMemo(() => {
    return isSuccess(visitType)
  }, [visitType])

  if (scheduledType === VisitScheduleType.now) {
    const isChatModality = modality === EVisitModalities.chat
    const providerType = successVisit
      ? t('visitCreation.confirmation.messages.providerTypes.successCoach')
      : t('visitCreation.confirmation.messages.providerTypes.provider')

    let description = t('visitCreation.confirmation.messages.defaultDescription', {
      appName: APP_NAME,
      providerType,
    })

    if (isChatModality) {
      description = t('visitCreation.confirmation.messages.chatDescription', {
        appName: APP_NAME,
        providerType,
      })

      if (!successVisit) {
        description += ' ' + t('visitCreation.confirmation.messages.emergencyEscalation')
      }
    }

    return (
      <>
        {!successVisit && <VisitConfirmationLocation displayLocation={displayLocation} />}
        <div
          className="typography-body bg-pantone-300 rounded-lg px-4 py-2 font-medium text-neutral-600"
          data-testid={TestIds.newVisit.label.confirmInstructions}
        >
          {description}
        </div>
      </>
    )
  }
  return <ScheduledVisitConfirmation {...props} displayLocation={displayLocation} />
}

export default VisitConfirmationChooser
